export default "__VITE_ASSET__df156c30__"